/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentStateEnum } from './PaymentStateEnum';
import {
    PaymentStateEnumFromJSON,
    PaymentStateEnumFromJSONTyped,
    PaymentStateEnumToJSON,
    PaymentStateEnumToJSONTyped,
} from './PaymentStateEnum';

/**
 * 
 * @export
 * @interface CustomerNew
 */
export interface CustomerNew {
    /**
     * 
     * @type {string}
     * @memberof CustomerNew
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerNew
     */
    identificationNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerNew
     */
    taxIdentificationNumber: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerNew
     */
    vatPayer: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerNew
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerNew
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerNew
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerNew
     */
    zip: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerNew
     */
    customerNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerNew
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerNew
     */
    phone: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerNew
     */
    contactPerson: string | null;
    /**
     * 
     * @type {number}
     * @memberof CustomerNew
     */
    partnerId: number | null;
    /**
     * 
     * @type {number}
     * @memberof CustomerNew
     */
    assignedToUserId: number | null;
    /**
     * 
     * @type {PaymentStateEnum}
     * @memberof CustomerNew
     */
    paymentState: PaymentStateEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerNew
     */
    isPayingParent: boolean;
    /**
     * 
     * @type {number}
     * @memberof CustomerNew
     */
    parentId: number | null;
}



/**
 * Check if a given object implements the CustomerNew interface.
 */
export function instanceOfCustomerNew(value: object): value is CustomerNew {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('identificationNumber' in value) || value['identificationNumber'] === undefined) return false;
    if (!('taxIdentificationNumber' in value) || value['taxIdentificationNumber'] === undefined) return false;
    if (!('vatPayer' in value) || value['vatPayer'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('customerNumber' in value) || value['customerNumber'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('contactPerson' in value) || value['contactPerson'] === undefined) return false;
    if (!('partnerId' in value) || value['partnerId'] === undefined) return false;
    if (!('assignedToUserId' in value) || value['assignedToUserId'] === undefined) return false;
    if (!('paymentState' in value) || value['paymentState'] === undefined) return false;
    if (!('isPayingParent' in value) || value['isPayingParent'] === undefined) return false;
    if (!('parentId' in value) || value['parentId'] === undefined) return false;
    return true;
}

export function CustomerNewFromJSON(json: any): CustomerNew {
    return CustomerNewFromJSONTyped(json, false);
}

export function CustomerNewFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerNew {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'identificationNumber': json['identificationNumber'],
        'taxIdentificationNumber': json['taxIdentificationNumber'],
        'vatPayer': json['vatPayer'],
        'country': json['country'],
        'city': json['city'],
        'street': json['street'],
        'zip': json['zip'],
        'customerNumber': json['customerNumber'],
        'email': json['email'],
        'phone': json['phone'],
        'contactPerson': json['contactPerson'],
        'partnerId': json['partnerId'],
        'assignedToUserId': json['assignedToUserId'],
        'paymentState': PaymentStateEnumFromJSON(json['paymentState']),
        'isPayingParent': json['isPayingParent'],
        'parentId': json['parentId'],
    };
}

export function CustomerNewToJSON(json: any): CustomerNew {
    return CustomerNewToJSONTyped(json, false);
}

export function CustomerNewToJSONTyped(value?: CustomerNew | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'identificationNumber': value['identificationNumber'],
        'taxIdentificationNumber': value['taxIdentificationNumber'],
        'vatPayer': value['vatPayer'],
        'country': value['country'],
        'city': value['city'],
        'street': value['street'],
        'zip': value['zip'],
        'customerNumber': value['customerNumber'],
        'email': value['email'],
        'phone': value['phone'],
        'contactPerson': value['contactPerson'],
        'partnerId': value['partnerId'],
        'assignedToUserId': value['assignedToUserId'],
        'paymentState': PaymentStateEnumToJSON(value['paymentState']),
        'isPayingParent': value['isPayingParent'],
        'parentId': value['parentId'],
    };
}

